import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { App } from './app/app';
import { appConfig } from './app/app.config';
import { dropStaleChunkEvent } from './app/utils/stale-chunk-reload';
import { environment } from './environments/environment';

Sentry.init({
  beforeSend: (event, hint) => dropStaleChunkEvent(event, hint.originalException, () => window.location.reload()),
  denyUrls: [/^iabjs:\/\//, /^safari-web-extension:\/\//, /^chrome-extension:\/\//, /^moz-extension:\/\//],
  dsn: environment.sentryDsn,
  enabled: environment.sentryEnabled,
  environment: environment.sentryEnvironment,
  ignoreErrors: [/window\.webkit\.messageHandlers/, /runtime\.sendMessage\(\)/],
  integrations: [Sentry.browserTracingIntegration()],
  release: environment.sentryRelease || undefined,
  tracesSampleRate: environment.production ? 0.1 : 1.0,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
